import React from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { PhoneNumbers } from "./types";
import { Input } from "../Input";

import "./styles.scss";

export const HookFormPhoneNumbers = () => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityDetailsPage.modalEditProfile.phoneNumbersForm.${key}`);

  const { control } = useFormContext<PhoneNumbers>();

  const additionalPhoneNumbers = useFieldArray({
    control,
    name: "additionalPhoneNumbers",
  });

  const onAddPhoneNumber = () => {
    additionalPhoneNumbers.append({ number: "" });
  };

  return (
    <div className="hook-form-phone-numbers">
      <h3>{t("primary_phone_number")}</h3>
      <Input name="primaryPhoneNumber.number" type="tel" />

      <h3>{t("additional_phone_numbers")}</h3>
      {additionalPhoneNumbers.fields.map((item, index) => {
        return (
          <div key={item.id} className="phone-number-row">
            <div className="phone-number-row-input-container">
              <Input
                name={`additionalPhoneNumbers.${index}.number`}
                type="tel"
              />
            </div>
            <button
              type="button"
              className="btn btn-border btn-border-red"
              onClick={() => additionalPhoneNumbers.remove(index)}
            >
              {t("remove")}
            </button>
          </div>
        );
      })}
      <div>
        <button
          type="button"
          className="btn btn-border"
          onClick={() => onAddPhoneNumber()}
        >
          {t("add_phone_number")}
        </button>
      </div>
    </div>
  );
};
